export const defaultDocumentData = {
    title: {
      english: "Why You should Never Retire",
      chinese: "为什么你永远不应该退休"
    },
    header: {
      text: "外刊双语精读 | 为什么你永远不应该退休",
      logoUrl: "https://qiniu-bjjrzy.bjjrzy.com/rsi_practice/qa/textbookContent/titleIcon.jpg"
    },
    summary: {
      title: "为什么你永远不应该退休",
      source: "选⾃The Economist"
    },
    chineseGuide: {
      title: "中⽂导读",
      content: [
        "退休意味着离开繁忙的⼯作世界，进⼊休闲⽣活",
        "但仍需⾯对收⼊、⽬标和关联性等潜在痛苦损失"
      ]
    },
    backgroundImage: "https://qiniu-bjjrzy.bjjrzy.com/rsi_practice/qa/textbookContent/bg.png",
    paragraphs: [
      {
        english: `In an episode of "The Sopranos", a popular television series which started airing in the 1990s, a gangster tells Tony, from the titular family, that he wants to retire. "What are you, a hockey player?" Tony snaps back. Non-fictional non-criminals who are considering an end to their working lives need not worry about broken fingers or other bodily harm. But they must still contend with other potentially painful losses: of income, purpose or, most poignantly, relevance`,
        chinese: "在《黑道家族》的一集中，这部始于1990年代的热门电视剧里，一个黑帮分子告诉托尼，这个同名家族的成员，他想要退休。'你是什么，曲棍球运动员吗？'托尼反驳道。那些考虑结束工作生涯的非虚构非罪犯不必担心手指骨折或其他身体伤害。但他们仍然必须面对其他潜在的痛苦损失：收入、目标，或者最令人痛心的，相关性。",
        words: [
          {
            name: "episode",
            phonetic: "英 /ˈepɪsəʊd/ 美 /ˈepɪsoʊd/",
            partOfSpeech: "n. 插曲，片段；一集",
            example: "I watched the latest episode of the series.",
            highlightWord: "episode", // 原形匹配示例
            scopeWord: "CET4 / CET6 / IELTS / GRE",
            chExample: "我看了这部剧的最新一集。"
          },
          {
            name: "gangster",
            phonetic: "英 /ˈɡæŋstə(r)/ 美 /ˈɡæŋstər/",
            partOfSpeech: "n. 黑帮分子，歹徒",
            example: "The gangsters were arrested by the police.",
            highlightWord: "gangsters", // 复数形式示例
            scopeWord: "CET4 / CET6 / IELTS / GRE",
            chExample: "那些黑帮分子被警察逮捕了。"
          },
          {
            name: "television",
            phonetic: "英 /ˈtelɪvɪʒn/ 美 /ˈtelɪvɪʒn/",
            partOfSpeech: "n. 电视，电视机",
            example: "She watched television all evening.",
            highlightWord: "television", // 原形匹配示例
            scopeWord: "CET4 / CET6 / IELTS / GRE",
            chExample: "她整个晚上都在看电视。"
          },
          {
            name: "air",
            phonetic: "英 /eə(r)/ 美 /er/",
            partOfSpeech: "v. 播出；播放",
            example: "The show is airing tonight at 8 PM.",
            highlightWord: "airing", // 现在分词形式示例
            scopeWord: "CET4 / CET6 / IELTS / GRE",
            chExample: "这个节目今晚8点播出。"
          },
          {
            name: "retire",
            phonetic: "英 /rɪˈtaɪə(r)/ 美 /rɪˈtaɪər/",
            partOfSpeech: "v. 退休；退下",
            example: "Many people are retiring later in life.",
            highlightWord: "retiring", // 现在分词形式示例
            scopeWord: "CET4 / CET6 / IELTS / GRE",
            chExample: "许多人在晚年退休。"
          },
          {
            name: "relevance",
            phonetic: "英 /ˈreləvəns/ 美 /ˈreləvəns/",
            partOfSpeech: "n. 相关性，关联性",
            example: "The relevance of this topic is clear.",
            highlightWord: "relevance", // 原形匹配示例
            scopeWord: "CET4 / CET6 / IELTS / GRE",
            chExample: "这个话题的相关性很明显。"
          }
        ]
      },
      // {
      //   english: `The question of when to stop working is more complex than it might seem. For many, retirement represents freedom from the daily grind, a chance to pursue hobbies, travel, or simply relax. But for others, particularly those whose identities are closely tied to their careers, the prospect of retirement can be daunting.`,
      //   chinese: "何时停止工作的问题比看起来更复杂。对许多人来说，退休代表着从日常繁重工作中解脱，有机会追求爱好、旅行或简单地放松。但对其他人，特别是那些身份与职业密切相关的人来说，退休的前景可能令人生畏。"
      // },
      // {
      //   english: `Research suggests that the transition to retirement can have significant psychological and social implications. The loss of professional identity, social connections, and sense of purpose can lead to depression and anxiety. However, those who plan carefully and maintain active lifestyles often find retirement to be one of the most fulfilling periods of their lives.`,
      //   chinese: "研究表明，向退休的过渡可能具有重大的心理和社会影响。失去职业身份、社会联系和目标感可能导致抑郁和焦虑。然而，那些仔细规划并保持积极生活方式的人往往发现退休是他们生活中最充实的时期之一。"
      // }
    ],
    phraseCollection: {
      title: "【短语积累】",
      items: [
        { content: "Marginalise a group - 边缘化一个群体" },
        { content: "Impairment of vision - 视力受损" },
        { content: "Moderately priced - 价格适中的" },
        { content: "Prestige of the university - 大学的声望" },
        { content: "Predictable outcome - 可预测的结果" },
        { content: "Measly salary - 微薄的薪水" }
      ]
    },
    paragraphSummary: {
      title: "【段落⼤意】",
      items: [
        { content: "⼈们考虑结束⼯作⽣涯时，不必担⼼身体伤害，但仍需⾯对收⼊、⽬标和关联性等潜在痛苦损失。" },
        { content: "⼀些⼈坚决不会退休，如乔治·阿玛尼和查理·芒格，他们在⾼龄时仍保持职业活动。" },
        { content: "像阿玛尼、巴菲特和芒格这样的⼈虽然特殊，但在职业上保持活跃并不独⼀⽆⼆，许多美国⼈表示可能永远不会退休。" }
      ]
    }
  };

